/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_day_number: NonNullable<unknown>, plan_price: NonNullable<unknown> }} Onboarding_Paywall_FooterInputs */

const en_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enjoy ${i?.trial_day_number} days for free, then ${i?.plan_price} annually. Cancel anytime.`)
};

const ar_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`استمتع بـ${i?.trial_day_number} يومًا مجانًا، ثم ${i?.plan_price} سنويًا. يمكنك الإلغاء في أي وقت.`)
};

const de_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genießen Sie ${i?.trial_day_number} kostenlos, dann ${i?.plan_price} jährlich. Jederzeit kündbar.`)
};

const es_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disfruta de ${i?.trial_day_number} días gratis, luego ${i?.plan_price} al año. Cancela en cualquier momento.`)
};

const fr_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profitez de ${i?.trial_day_number} jours gratuits, puis ${i?.plan_price} par an. Vous pouvez vous désabonner à tout moment.`)
};

const it_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Goditi ${i?.trial_day_number} giorni gratis, poi ${i?.plan_price} all'anno. Puoi annullare in qualsiasi momento.`)
};

const ja_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}日間は無料でお試し。以後は年間${i?.plan_price}。いつでもキャンセル可能。`)
};

const ko_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}일간 무료로 체험하고 연간 ${i?.plan_price} 가격에 이용할 수 있어요. 취소는 언제든지 가능해요.`)
};

const pt_br_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aproveite ${i?.trial_day_number} dias de graça, e depois pague ${i?.plan_price} anualmente. Cancele a quando quiser.`)
};

const ru_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пользуйтесь ${i?.trial_day_number} дней бесплатно, а затем за ${i?.plan_price} в год. Отменяйте в любое время.`)
};

const th_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับการใช้งานฟรี ${i?.trial_day_number} วัน หลังจากนั้นเพียงแค่ ${i?.plan_price} ต่อปี โดยสามารถยกเลิกเมื่อไหร่ก็ได้`)
};

const tr_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number} gün ücretsiz, ardından yıllık ${i?.plan_price} fiyatına yararlan. İstediğin zaman iptal et.`)
};

const zh_cn_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费试用 ${i?.trial_day_number} 天，之后每年 ${i?.plan_price}。可随时取消。`)
};

const zh_tw_onboarding_paywall_footer = /** @type {(inputs: Onboarding_Paywall_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免費試用 ${i?.trial_day_number} 天，之後每年 ${i?.plan_price}。可隨時取消。`)
};

/**
* | output |
* | --- |
* | "Enjoy {trial_day_number} days for free, then {plan_price} annually. Cancel anytime." |
*
* @param {Onboarding_Paywall_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_footer = /** @type {((inputs: Onboarding_Paywall_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_footer(inputs)
	if (locale === "ar") return ar_onboarding_paywall_footer(inputs)
	if (locale === "de") return de_onboarding_paywall_footer(inputs)
	if (locale === "es") return es_onboarding_paywall_footer(inputs)
	if (locale === "fr") return fr_onboarding_paywall_footer(inputs)
	if (locale === "it") return it_onboarding_paywall_footer(inputs)
	if (locale === "ja") return ja_onboarding_paywall_footer(inputs)
	if (locale === "ko") return ko_onboarding_paywall_footer(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_footer(inputs)
	if (locale === "ru") return ru_onboarding_paywall_footer(inputs)
	if (locale === "th") return th_onboarding_paywall_footer(inputs)
	if (locale === "tr") return tr_onboarding_paywall_footer(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_footer(inputs)
	return zh_tw_onboarding_paywall_footer(inputs)
});